import React from 'react'
import styled from 'styled-components'

const FilterButtonStyled = styled.button<{ checked: boolean }>`
  border: none;
  cursor: pointer;
  height: 30px;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 8px;
  background: ${({ checked }) => (checked ? '#4afc39' : 'transparent')};
  border: 1px solid ${({ checked }) => (checked ? '#1e1e1e' : '#6C7284')};
  color: ${({ checked }) => (checked ? '#1e1e1e' : '#6C7284')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
`

interface FilterButtonI {
  checked: boolean
  onClick: () => void
  children: string | JSX.Element | JSX.Element[] | Element | Element[] | any
}

const FilterButton: React.FC<FilterButtonI> = ({ checked, onClick, children }) => {
  return (
    <FilterButtonStyled checked={checked} onClick={() => onClick()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
        <path d="M9 12l2 2l4 -4" />
      </svg>
      {children}
    </FilterButtonStyled>
  )
}
export default FilterButton
